// import {loggerFactory} from "@mecatran/logger-factory";
import {serializr, indirectReference, classConstructorParam  } from '@mecatran/serializr-extensions';

import * as scheduleModel from "./model.mjs";

// =========
// variables
// --------- 

var {   createModelSchema, 
    createSimpleSchema, 
    primitive, 
    reference, 
    date, raw, list, object, 
    optional, alias,
    identifier, map, mapAsArray , 
    custom, 
    getDefaultModelSchema, 
    setDefaultModelSchema,
    serialize, 
    deserialize } = serializr;
 

// ==================
// classes, Functions
// ------------------

var handler  = {
    beforeDeserialize: function(
        callback,
        jsonValue,
        jsonParentValue,
        propNameOrIndex,
        context,
        propDef
    ) {
        if (typeof jsonValue === "string") {
            callback(null, jsonValue)
        } else if (typeof jsonValue === "number") {
            callback(null, jsonValue.toString())
        } else {
            callback(new Error("something went wrong before deserialization"))
        }
    }
}

// console.log('scheduleModel:',scheduleModel);

export function getScheduleModel(isIndex){
    console.log('schema:isIndex:',isIndex)
        
    function factory(clazz ){
        return function(){
            return new clazz();
        }
    }

    var schemaDirection = {
        factory : (context) => new scheduleModel.Direction(context.value),
        props : {
            '*' : true
        }
    };


    var schemaStop = {
        factory : factory(scheduleModel.Stop),
        props : {
            isStation : true,
            id : identifier(),
            code : true,
            name : true,
            description : true,
            city : true,
            city2 : true,
            code : true,
            stopIds : isIndex ? false : list(reference(scheduleModel.Stop)),  // false
            agencyIds : list(raw()),
            isDestination : true,
            lat : true,
            lon : true,
            itineraries : isIndex ? false :  list(indirectReference(scheduleModel.Itinerary)), //,{ identifier : 'stopId'}
            erpDest : true,
            erpHome : true
        }
    }


    var schemaDestination = {
        factory : factory(scheduleModel.Destination),
        props : {
            setId : raw(),
            generatedAt : raw(),
            version : raw(),
            file: raw(),
            destination : object(scheduleModel.Stop),
            stopIds : list(reference(scheduleModel.Stop))  
        }
    }


    var schemaRoute = {
        factory : factory(scheduleModel.Route),
        props : {
            id : identifier(),
            agencyId : true,
            shortName : true,
            longName : true,
            type : true,
            color : true,
            textColor : true
        }
    }

    var schemaRange = {
        factory : factory(scheduleModel.Range),
        props : {
            from : true, 
            to : true
        }
    }

    var schemaCalendar = {
        factory : factory(scheduleModel.Calendar),
        props : {
            ranges : list(object(scheduleModel.Range)),
            dows : raw(),        // ### or instanciate a class and initialize with the value  (or do it later)
            negativeExceptions : raw()  // ### or instanciate a class and initialize with the value 
        }
    }

    var schemaTime = {
        factory : factory(scheduleModel.Time),
        props : {
            stopId : reference(scheduleModel.Stop),
            dep : true,    // ### date 
            pickupType : raw(),
            dropoffType : raw()  // convert into int/Number 
        }
    }


    var schemaTrip = {
        factory : factory(scheduleModel.Trip),
        props : {
            tripIds : raw(), // for info only
            routeId : reference(scheduleModel.Route),
            headsign : true,
            tripName : true,
            blockId : true,
            extLibelle : optional(),
            extPhone : optional(),
            extEmail : optional(),
            directionId : classConstructorParam(scheduleModel.Direction), //primitive(handler),    // converts number -> string
            times : list(object(scheduleModel.Time))
        }
    }


    var schemaItinerary = {
        factory : factory(scheduleModel.Itinerary),
        props : {
            id : identifier(),
            calendar : object(scheduleModel.Calendar),
            trips : list(object(scheduleModel.Trip))
        }
    }

    var schemaItineraryIndex = {
        factory : factory(scheduleModel.ItineraryIndex),
        props : {
            setId : raw(),
            generatedAt : raw(),
            version : raw(),
            file: raw(),
            destination : object(scheduleModel.Stop),
            stops : list(object(scheduleModel.Stop)),
            routes : list(object(scheduleModel.Route)),
            itineraries :  list(object(scheduleModel.Itinerary))      
        }
    }

    var schemaDestinationIndex = {
        factory : factory(scheduleModel.DestinationIndex),
        props : {
            items : list(object(scheduleModel.Destination))
        }
    }

    setDefaultModelSchema(scheduleModel.Direction, schemaDirection);
    setDefaultModelSchema(scheduleModel.Destination, schemaDestination);
    setDefaultModelSchema(scheduleModel.Stop, schemaStop);
    setDefaultModelSchema(scheduleModel.Route, schemaRoute);
    setDefaultModelSchema(scheduleModel.Range, schemaRange);
    setDefaultModelSchema(scheduleModel.Calendar, schemaCalendar);
    setDefaultModelSchema(scheduleModel.Time, schemaTime);
    setDefaultModelSchema(scheduleModel.Trip, schemaTrip);
    setDefaultModelSchema(scheduleModel.Itinerary, schemaItinerary);
    setDefaultModelSchema(scheduleModel.ItineraryIndex, schemaItineraryIndex);
    setDefaultModelSchema(scheduleModel.DestinationIndex, schemaDestinationIndex);

    return scheduleModel;
}




